"use client";

import * as React from "react";
import {
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

type FaqItemProps = {
  question: string;
  answer: string;
  category?: string;
  value: string;
  className?: string;
};

const FaqItem = React.forwardRef<HTMLDivElement, FaqItemProps>(
  ({ question, answer, category, value, className }, ref) => {
    return (
      <AccordionItem
        className={cn(
          "mb-4 rounded-xl",
          "bg-card text-card-foreground",
          "border border-border/60",
          "shadow-sm transition-all duration-200",
          "hover:border-border/80 hover:shadow-md",
          className
        )}
        ref={ref}
        value={value}
      >
        <AccordionTrigger
          className={cn(
            "px-6 py-5 text-left hover:no-underline",
            "data-[state=open]:border-border/60 data-[state=open]:border-b",
            "transition-all duration-200"
          )}
        >
          <div className="flex flex-col gap-3 text-left">
            {category && (
              <Badge className="w-fit font-normal text-xs" variant="secondary">
                {category}
              </Badge>
            )}
            <h3 className="font-bold font-heading text-foreground text-lg leading-tight transition-colors duration-200 group-hover:text-primary">
              {question}
            </h3>
          </div>
        </AccordionTrigger>
        <AccordionContent className="px-6 pt-2 pb-6">
          <div className="text-muted-foreground text-optimal">{answer}</div>
        </AccordionContent>
      </AccordionItem>
    );
  }
);

FaqItem.displayName = "FaqItem";

export { FaqItem };
